declare const __CEVIRI_SURUM__: string;

// اللَّهُ لَا إِلَٰهَ إِلَّا هُوَ الْحَيُّ الْقَيُّومُ ۚ لَا تَأْخُذُهُ سِنَةٌ وَلَا نَوْمٌ ۚ
// لَهُ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ ۗ مَنْ ذَا الَّذِي يَشْفَعُ عِنْدَهُ إِلَّا بِإِذْنِهِ ۚ
// يَعْلَمُ مَا بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ ۖ وَلَا يُحِيطُونَ بِشَيْءٍ مِنْ عِلْمِهِ إِلَّا بِمَا شَاءَ ۚ
// وَسِعَ كُرْسِيُّهُ السَّمَاوَاتِ وَالْأَرْضَ ۖ وَلَا يَئُودُهُ حِفْظُهُمَا ۚ وَهُوَ الْعَلِيُّ الْعَظِيمُ
// (Bakara 255)

import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import HttpBackend from 'i18next-http-backend'

// YEDEK ZINCIRININ IKI DILI PAKETE GOMULU (olculdu 2026-08-31): once ikisi de HTTP'den
// iniyordu -- Turkce bir kullanici icin tr/common.json (44 kB, 75 ms) VE fallback zinciri
// yuzunden en/common.json (43 kB), toplam 2 istek + 87 kB. Ustelik i18next varsayilan
// useSuspense=true oldugu icin ekran bu dosyalar inene kadar BOS kaliyordu: dil, giris
// ekranini dogrudan bekletiyordu.
//
// Gomulu hallerinin bedeli 28 kB gzip; karsiliginda 2 istek, 87 kB transfer ve 75 ms bekleme
// ortadan kalkiyor -- ceviriler ilk boyamada HAZIR.
//
// Kalan 64 dil HttpBackend ile istege bagli iner (partialBundledLanguages bunu saglar):
// 3,3 MB'lik dil klasorunun tamami PAKETE GIRMEZ, yalnizca yedek zinciri girer.
import trCommon from '../../public/locales/tr/common.json'
import enCommon from '../../public/locales/en/common.json'

export const SUPPORTED_LANGUAGES = [
  { code: 'tr', name: 'Türkçe', flag: 'tr', dir: 'ltr' },
  { code: 'en', name: 'English', flag: 'gb', dir: 'ltr' },
  { code: 'ar', name: 'العربية', flag: 'sa', dir: 'rtl' },
  { code: 'de', name: 'Deutsch', flag: 'de', dir: 'ltr' },
  { code: 'fr', name: 'Français', flag: 'fr', dir: 'ltr' },
  { code: 'it', name: 'Italiano', flag: 'it', dir: 'ltr' },
  { code: 'es', name: 'Español', flag: 'es', dir: 'ltr' },
  { code: 'pt', name: 'Português', flag: 'pt', dir: 'ltr' },
  { code: 'nl', name: 'Nederlands', flag: 'nl', dir: 'ltr' },
  { code: 'ru', name: 'Русский', flag: 'ru', dir: 'ltr' },
  { code: 'uk', name: 'Українська', flag: 'ua', dir: 'ltr' },
  { code: 'pl', name: 'Polski', flag: 'pl', dir: 'ltr' },
  { code: 'cs', name: 'Čeština', flag: 'cz', dir: 'ltr' },
  { code: 'sk', name: 'Slovenčina', flag: 'sk', dir: 'ltr' },
  { code: 'hu', name: 'Magyar', flag: 'hu', dir: 'ltr' },
  { code: 'ro', name: 'Română', flag: 'ro', dir: 'ltr' },
  { code: 'bg', name: 'Български', flag: 'bg', dir: 'ltr' },
  { code: 'el', name: 'Ελληνικά', flag: 'gr', dir: 'ltr' },
  { code: 'sr', name: 'Srpski', flag: 'rs', dir: 'ltr' },
  { code: 'hr', name: 'Hrvatski', flag: 'hr', dir: 'ltr' },
  { code: 'bs', name: 'Bosanski', flag: 'ba', dir: 'ltr' },
  { code: 'sl', name: 'Slovenščina', flag: 'si', dir: 'ltr' },
  { code: 'mk', name: 'Македонски', flag: 'mk', dir: 'ltr' },
  { code: 'sq', name: 'Shqip', flag: 'al', dir: 'ltr' },
  { code: 'me', name: 'Crnogorski', flag: 'me', dir: 'ltr' },
  { code: 'az', name: 'Azərbaycanca', flag: 'az', dir: 'ltr' },
  { code: 'kk', name: 'Қазақша', flag: 'kz', dir: 'ltr' },
  { code: 'uz', name: 'Oʻzbekcha', flag: 'uz', dir: 'ltr' },
  { code: 'tk', name: 'Türkmençe', flag: 'tm', dir: 'ltr' },
  { code: 'ky', name: 'Кыргызча', flag: 'kg', dir: 'ltr' },
  { code: 'tt', name: 'Татарча', flag: 'ru', dir: 'ltr' },
  { code: 'fa', name: 'فارسی', flag: 'ir', dir: 'rtl' },
  { code: 'ku', name: 'Kurdî', flag: 'iq', dir: 'ltr' },
  { code: 'he', name: 'עברית', flag: 'il', dir: 'rtl' },
  { code: 'ja', name: '日本語', flag: 'jp', dir: 'ltr' },
  { code: 'ko', name: '한국어', flag: 'kr', dir: 'ltr' },
  { code: 'zh', name: '中文', flag: 'cn', dir: 'ltr' },
  { code: 'hi', name: 'हिन्दी', flag: 'in', dir: 'ltr' },
  { code: 'bn', name: 'বাংলা', flag: 'bd', dir: 'ltr' },
  { code: 'ur', name: 'اردو', flag: 'pk', dir: 'rtl' },
  { code: 'th', name: 'ไทย', flag: 'th', dir: 'ltr' },
  { code: 'vi', name: 'Tiếng Việt', flag: 'vn', dir: 'ltr' },
  { code: 'ms', name: 'Bahasa Melayu', flag: 'my', dir: 'ltr' },
  { code: 'id', name: 'Bahasa Indonesia', flag: 'id', dir: 'ltr' },
  { code: 'tl', name: 'Filipino', flag: 'ph', dir: 'ltr' },
  { code: 'sw', name: 'Kiswahili', flag: 'tz', dir: 'ltr' },
  { code: 'am', name: 'አማርኛ', flag: 'et', dir: 'ltr' },
  { code: 'ha', name: 'Hausa', flag: 'ng', dir: 'ltr' },
  { code: 'yo', name: 'Yorùbá', flag: 'ng', dir: 'ltr' },
  { code: 'ig', name: 'Igbo', flag: 'ng', dir: 'ltr' },
  { code: 'zu', name: 'isiZulu', flag: 'za', dir: 'ltr' },
  { code: 'af', name: 'Afrikaans', flag: 'za', dir: 'ltr' },
  { code: 'so', name: 'Soomaali', flag: 'so', dir: 'ltr' },
  { code: 'rw', name: 'Kinyarwanda', flag: 'rw', dir: 'ltr' },
  { code: 'mg', name: 'Malagasy', flag: 'mg', dir: 'ltr' },
  { code: 'ln', name: 'Lingála', flag: 'cd', dir: 'ltr' },
  { code: 'wo', name: 'Wolof', flag: 'sn', dir: 'ltr' },
  { code: 'ka', name: 'ქართული', flag: 'ge', dir: 'ltr' },
  { code: 'hy', name: 'Հայերեն', flag: 'am', dir: 'ltr' },
  { code: 'sv', name: 'Svenska', flag: 'se', dir: 'ltr' },
  { code: 'da', name: 'Dansk', flag: 'dk', dir: 'ltr' },
  { code: 'no', name: 'Norsk', flag: 'no', dir: 'ltr' },
  { code: 'fi', name: 'Suomi', flag: 'fi', dir: 'ltr' },
  { code: 'et', name: 'Eesti', flag: 'ee', dir: 'ltr' },
  { code: 'lv', name: 'Latviešu', flag: 'lv', dir: 'ltr' },
  { code: 'lt', name: 'Lietuvių', flag: 'lt', dir: 'ltr' },
] as const

export type LangCode = typeof SUPPORTED_LANGUAGES[number]['code']

export const DEFAULT_NS = 'common'
export const NAMESPACES = ['common'] as const

export function getFlagUrl(flagCode: string): string {
  return `${import.meta.env.BASE_URL}flags/${flagCode}.svg`
}

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // BASLANGIC DILI: kullanicinin kendi secimi, yoksa 'tr'. Acikca verilmesi SART — detector
    // localStorage'da kayit bulamayinca i18next fallbackLng'in ILK uyesine ('en') duser ve arayuz
    // Ingilizce acilir. brandService ise ayni durumda 'tr' varsayar (marka metnini oyle ister).
    // Iki katmanin farkli varsayilani KARMA EKRAN uretiyordu — olculdu 2026-08-31, eportaldev
    // login: sol panel ve marka metni Turkce, form tamamen Ingilizce (Email/Password/Remember me/
    // Sign In). Ayni deger burada da kullanilinca iki katman ayni dili konusur.
    // Yedek zinciri ('en' -> 'tr') pakete gomulu; digerleri HttpBackend'den.
    // partialBundledLanguages SART: olmazsa backend gomulu dilleri de tekrar indirir.
    resources: { tr: { common: trCommon }, en: { common: enCommon } },
    partialBundledLanguages: true,
    lng: (typeof localStorage !== 'undefined' && localStorage.getItem('i18nextLng')) || 'tr',
    // YEDEK ZINCIRI: cevirisi olmayan anahtar once INGILIZCEye duser, o da yoksa Turkceye.
    // Tek 'tr' yedegi, Ingilizce arayuz secen kullaniciya Turkce metin gosteriyordu — 66 dil
    // dosyasi var ama hepsi ayni anda tamamlanamaz; yedek Ingilizce olunca eksik ceviri en
    // azindan evrensel bir dilde okunur (2026-08-29 kullanici bildirimi). Bu zincir DEGISMEDI;
    // yukaridaki 'lng' yalniz BASLANGIC dilini belirler, eksik ceviri yedegini degil.
    fallbackLng: ['en', 'tr'],
    supportedLngs: SUPPORTED_LANGUAGES.map(l => l.code),
    nonExplicitSupportedLngs: true,
    defaultNS: DEFAULT_NS,
    ns: [...NAMESPACES],
    interpolation: { escapeValue: false },
    backend: {
      loadPath: `${import.meta.env.BASE_URL}locales/{{lng}}/{{ns}}.json?v=${__CEVIRI_SURUM__}`,
    },
    detection: {
      // YALNIZ kullanıcının kendi seçimi (localStorage). Tarayıcı dili BİLEREK kullanılmıyor:
      // ürün Türkçe konuşuyor (ekranlardaki metinlerin çoğu Türkçe yazılı), ama sunucu/kurumsal
      // makinelerin tarayıcısı çoğu kez İngilizce. navigator algılaması açıkken dil sessizce 'en'e
      // düşüyor ve ortaya KARMA ekran çıkıyordu: html lang="tr", her yer Türkçe, ama markadan gelen
      // metinler (login karşılama + özellik listesi) İngilizce. Ölçüm 2026-08-16: navigator="en",
      // i18nextLng="en", ekran tamamen Türkçe. Dili kullanıcı header'dan seçer; seçmezse tr.
      order: ['localStorage'],
      caches: ['localStorage'],
      // tr-TR / en-US gibi bölge kodlarını taban dile indir (tr, en) — locale dosyaları taban dilde.
      convertDetectedLanguage: (lng: string) => lng.split('-')[0] ?? lng,
    },
    // Bölge varyantı yerine taban dili yükle (navigator 'tr-TR' → 'tr')
    load: 'languageOnly',
    // preload: ['tr'] KALDIRILDI — 'tr' artik pakete gomulu, on-yukleme istegi anlamsizdi.
  })

/**
 * <html lang/dir> aktif dile eşitlenir.
 *
 * Bu sadece kozmetik değil: CSS "text-transform: uppercase" harf çevrimini lang'e göre yapar.
 * lang="tr" kalınca İngilizce ekranda "SHIPMENT" yerine "SHİPMENT", "DAILY" yerine "DAİLY"
 * çıkıyordu (Türkçe i→İ kuralı). Ölçüm 2026-08-29, CX Genel Bakış panosu.
 */
function belgeDiliniEsitle(code: string) {
  const lang = SUPPORTED_LANGUAGES.find(l => l.code === code)
  document.documentElement.lang = code
  document.documentElement.dir = lang?.dir ?? 'ltr'
}

// Açılışta da eşitle: setLanguage yalnız kullanıcı dili DEĞİŞTİRİNCE çalışıyordu, kayıtlı dille
// açılan oturumda index.html'deki lang="tr" olduğu gibi kalıyordu.
i18n.on('initialized', () => belgeDiliniEsitle(i18n.resolvedLanguage ?? i18n.language))
i18n.on('languageChanged', (lng: string) => belgeDiliniEsitle(lng))

export function setLanguage(code: string) {
  const lang = SUPPORTED_LANGUAGES.find(l => l.code === code)
  if (lang) {
    i18n.changeLanguage(code)
    belgeDiliniEsitle(code)
    localStorage.setItem('i18nextLng', code)
  }
}

export default i18n

// URUN SAYFALARI CEVIRIYI BURADAN ALIR (apps/<urun>/frontend).
// Dogrudan 'react-i18next' import edilince vite alias'i AYRI bir modul ornegi cozuyor ve o
// ornek init EDILMEMIS oluyor: t() cevirmek yerine ham anahtari donuyordu ("cx.genelBakis"
// ekranda goruldu, 2026-08-29). Tek kapi = tek ornek.
export { useTranslation, Trans } from 'react-i18next';
